<template>
  <div class="p-20">
    <el-card class="mb-20">
      <app-filter :filter-list="table_filter" @search="search" />
    </el-card>
    <el-card>
      <div class="flex justify-between mb-20">
        <div>
          <el-select v-model="batch.value" size="mini" class="mr-20" placeholder="请选择批量操作">
            <el-option v-for="item in batch.options" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <el-button size="mini" type="primary" @click="onBatch">批量操作</el-button>
        </div>
        <div>
          <el-button type="primary" size="mini" @click="onAdd">新增</el-button>
        </div>
      </div>
      <app-table ref="table" :table-key="table_key" :tablep="table_params" :get-data="getTitleList" :is-row-click="false" :check="true" @select-tr="onSelectionChange" />
    </el-card>
    <!-- 新增/编辑弹窗 -->
    <el-dialog v-bind="dialog_config.props" :title="dialog_config.title" :visible.sync="dialog_config.is_show">
      <app-form
        v-if="dialog_config.is_show"
        ref="ad_form"
        :form-data="dialog_config.form_config"
        default-label-width="100px"
        @confirm="dialog_config.confirm"
        @cancel="dialog_config.is_show = false"
      >
        <template #custom="{ form_key }">
          <!-- 动态词包 -->
          <div v-if="form_key === 'name'">
            <el-link v-for="item in pageConfig.word_list" :key="item" type="primary" :underline="false" class="mr-10" @click="insertWord(item)">+{{ item }}</el-link>
          </div>
        </template>
      </app-form>
    </el-dialog>
    <!-- 批量新增弹窗 -->
    <el-dialog :title="batch_add_config.title" :visible.sync="batch_add_config.is_show" v-bind="batch_add_config.props">
      <batch-title ref="batch_title_ref" :page-config="pageConfig" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="batch_add_config.is_show = false">取消</el-button>
        <el-button type="primary" @click="batch_add_config.confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TitleResource from '@/api/title';
const titleResource = new TitleResource();
import { formDataAssign } from '@/tools/form';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
    'app-form': () => import('@/components/app-form'),
    'batch-title': () => import('@/views/auxiliary/title/components/batch/index.vue'),
  },
  props: {
    pageConfig: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      /** 表格多选数据 */
      multiple_selection: [],
      /** 批量操作 */
      batch: {
        value: 'add',
        options: [
          {
            label: '批量新增',
            value: 'add',
          },
          {
            label: '批量删除',
            value: 'del',
          },
        ],
      },
      /** 批量新增弹窗 */
      batch_add_config: {
        is_show: false,
        title: '批量新增',
        props: {
          width: '800px',
        },
        confirm: () => {},
      },
      /** 过滤项 */
      table_filter: require('@/views/auxiliary/title/model/table-filter')(this),
      /** 表头数据 */
      table_key: require('@/views/auxiliary/title/model/table-key')(this),
      /** 新增/编辑弹窗配置 */
      dialog_config: {
        is_show: false,
        title: '新增',
        id: null,
        props: {
          width: '500px',
        },
        form_config: {},
        confirm: () => {},
      },
      /** 表格请求参数 */
      table_params: {
        advertiser: '',
        page: 1,
        limit: 10,
      },
    };
  },
  created() {
    Object.assign(this.table_params, { advertiser: this.pageConfig.advertiser });
  },
  methods: {
    /**
     * 替换词包模板
     * @param {string} template 词包模板
     * @param {string} value 值
     * @returns {string}
     */
    replaceContext(template, value) {
      return template.replace(/context/g, value);
    },

    /**
     * 搜索
     * @param {Object} params 查询数据
     */
    search(params) {
      Object.assign(this.table_params, params);
      this.$refs.table.seekTable();
    },

    /**
     * 新增
     */
    onAdd() {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '新增',
        form_config: require('@/views/auxiliary/title/model/form-config')(this),
        confirm: (params) => {
          titleResource
            .creatApi({ advertiser: this.pageConfig.advertiser, ...params })
            .then(() => {
              this.$message.success('新增成功！');
              this.dialog_config.is_show = false;
              this.$refs.table.seekTable();
            });
        },
      });
      this.addNameFieldRule();
    },

    /**
     * 设置标题表单规则
     */
    addNameFieldRule() {
      const { getUseWordCount, rules } = this.pageConfig;
      const { name } = this.dialog_config.form_config;
      const rule = {
        required: true,
        validator: (rule, value, callback) => {
          if (rules.use_word_limit && getUseWordCount(value) > rules.use_word_limit) {
            callback(new Error(rule.message));
          } else {
            callback();
          }
        },
        message: `最多能使用${rules.use_word_limit}个动态词包`,
        trigger: ['change'],
      };
      name.rules[name.rules.length] = rule;
    },

    /**
     * 编辑
     * @param {Object} data 列表项数据
     * @param {number} id 标题ID
     */
    onEdit(data, id) {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '编辑',
        id,
        form_config: require('@/views/auxiliary/title/model/form-config')(this),
        confirm: (params) => {
          titleResource.editApi(params, this.dialog_config.id).then(() => {
            this.$message.success('编辑成功！');
            this.dialog_config.is_show = false;
            this.$refs.table.seekTable();
          });
        },
      });
      formDataAssign(this.dialog_config.form_config, data);
      this.addNameFieldRule();
    },

    /**
     * 删除
     * @param {number[]} source_ids 标题ID的集合
     */
    onDelete({ source_ids, rows, is_batch = false }) {
      const h = this.$createElement;
      this.$msgbox({
        title: '提示',
        message: h('div', null, [
          h('p', null, is_batch ? `已选中标题数：${source_ids.length}` : rows[0].name),
          h('p', null, [
            h('span', null, '是否'),
            h('span', {
              style: {
                color: '#F56C6C',
                margin: '0 5px',
              },
            }, '删除'),
            h('span', null, '当前已选中的标题'),
          ]),
        ]),
        showCancelButton: true,
        center: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        titleResource.deleteApi({ source_ids }).then(() => {
          this.$message.success('删除成功！');
          this.$refs.table.seekTable();
        });
      });
    },

    /**
     * 获取标题列表
     * @param {*} params
     */
    getTitleList(params) {
      return new Promise((resolve, reject) => {
        titleResource.getApi(params).then(resolve).catch(reject);
      });
    },

    /** 表格多选事件 */
    onSelectionChange(val) {
      this.multiple_selection = val;
    },

    /** 批量操作 */
    onBatch() {
      switch (this.batch.value) {
        case 'add':
          this.onBatchAdd();
          break;
        case 'del':
          this.onBatchDel();
          break;
        default:
          break;
      }
    },

    /**
     * 批量删除
     */
    onBatchDel() {
      if (!this.multiple_selection.length) {
        this.$message.warning('请选择标题！');
        return;
      }
      const ids = this.multiple_selection.map(({ id }) => id);
      this.onDelete({
        source_ids: ids,
        rows: this.multiple_selection,
        is_batch: true,
      });
    },

    /**
     * 批量新增
     */
    async onBatchAdd() {
      Object.assign(this.batch_add_config, {
        is_show: true,
        confirm: async() => {
          try {
            const res = await this.$refs['batch_title_ref'].onBatchAdd();
            this.$message.success('批量新增成功！');
            this.batch_add_config.is_show = false;
            this.$refs.table.seekTable();
            return Promise.resolve(res);
          } catch (error) {
            this.$message.error(error.message || '批量新增失败！');
          }
        },
      });
    },

    /**
     * 单个编辑/新增插入动态词包
     * @param {string} word 词包
     */
    insertWord(word) {
      const { name } = this.dialog_config.form_config;
      name.value += this.replaceContext(this.pageConfig.word_template, word);
    },
  },
};
</script>
